module.exports = __webpack_public_path__ + "static/media/Eticketlogo.eb0974ab.png";